import React from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import MessageThreads from '../parts/MessageThreads';
import MessageThreadMessages from '../parts/MessageThreadMessages';

const styles = theme => ({
  root: {
    height: 'calc(100vh - 104px)', // app bar & tabs
    overflow: 'hidden',
  },
  threadMessagesWrapper: {
    height: '100%',
    zIndex: -1,
  },
});

const mapStateToProps = state => {
  return {
    selectedPupil: state.selectedPupil,
    messagesSelectedThread: state.messagesSelectedThread,
  };
};

class MobileMessagesPage extends React.Component {
  render() {
    const {
      classes,
      selectedPupil,
      messagesSelectedThread,
      threadsDefaultSearch,
    } = this.props;

    const apiUrl = `${window.apiMessagingUrl}/getteacherstomessage`;
    const apiParams = {
      pupil_id: selectedPupil
        ? selectedPupil.id
        : 0,
    };

    return (
      <div className={`mobile-messages-page ${classes.root}`}>
        <MessageThreads
          apiUrl={apiUrl}
          apiParams={apiParams}
          listType="teacher"
          defaultSearch={threadsDefaultSearch}
          useSuspense={false}
          style={{
            display: messagesSelectedThread ? 'none' : 'block',
          }}
        />
        {messagesSelectedThread && (
          <div className={classes.threadMessagesWrapper}>
            <MessageThreadMessages useSuspense={false} />
          </div>
        )}
      </div>
    );
  }
}

export default connect(mapStateToProps)(
  withStyles(styles)(MobileMessagesPage)
);
